import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-secondarymenu',
  templateUrl: './secondarymenu.component.html',
  styleUrls: ['./secondarymenu.component.css']
})
export class SecondarymenuComponent implements OnInit {

  isAdmin = false;
  public userrole: string;

  constructor(private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.userrole = sessionStorage.getItem('USER_ROLE');
    if (this.userrole === 'ADMIN') {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
  }
}
